import React from 'react';
import { ButtonGroup, Grid } from '@mui/material';
import getBaseEditor, { CommandPanels } from '../../BaseEditor';
import { SetPasswordButton } from '../../../components/Styled/Buttons';
import Group from './group';
import ActivateUserButton from './ActivateButton';

const editorRenderer = (getControl, {
  data, reload, dataSetter, isChanged,
}) => (
  <Grid container rowGap={3} columnSpacing={4}>
    <Grid item sm={4}>
      {getControl('username')}
    </Grid>
    <Grid item sm={4}>
      {getControl('first_name')}
    </Grid>
    <Grid item sm={4}>
      {getControl('last_name')}
    </Grid>
    <Grid item sm={3}>
      {getControl('email')}
    </Grid>
    <Grid item sm={3}>
      {getControl('profile__org', { backend: '/api/catalog/orgs/' })}
    </Grid>
    <Grid item sm={3}>
      {data && (
        <Group onChange={dataSetter} data={data} />
      )}
    </Grid>
    <Grid item sm={3}>
      {getControl('budgetary_institution', { canErase: true })}
    </Grid>
    <Grid item sm={12}>
      {/* {getControl('is_staff')} */}
      {getControl('is_superuser')}
    </Grid>
    <Grid item sm={12}>
      <ButtonGroup>
        <SetPasswordButton
          disabled={!data.id || !data.is_active || isChanged}
          userid={data.id}
          onSuccess={reload}
          email={data.email}
        />
        <ActivateUserButton
          disabled={!data.id}
          userid={data.id}
          active={data.is_active}
          onSuccess={reload}
        />
      </ButtonGroup>
    </Grid>
  </Grid>
);

export default getBaseEditor(editorRenderer, '/api/core/user/', CommandPanels.catCommandPanel);
